<template>
  <div class="pa-4">
    <h3 class="ml-4 my-4">{{ $t("message.create_email_template") }}</h3>
    <div v-if="loading" class="text-center">
      <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
    </div>

    <div v-else-if="emailTemplate" class="text-center">
      <v-card-title class="pb-0 mb-0">
        <v-text-field outlined dense :label="$t('message.name')" outline v-model="emailTemplate.name"></v-text-field>
      </v-card-title>
      <v-card-title class="pb-0 mb-0">
        <v-text-field outlined dense :label="$t('message.subject')" outline
          v-model="emailTemplate.subject"></v-text-field>
      </v-card-title>
      <v-card-text>
      </v-card-text>
      <v-card-text>
        <v-switch v-model="showHtmlEditor" :label="'HTML'"></v-switch>
        <vue-editor v-if="!showHtmlEditor" v-model="emailContents" :editor-toolbar="editorToolbar" />
        <v-textarea v-else style="font-family: 'Courier New', monospace;" hide-details outlined dense rows="6"
          v-model="emailContents"></v-textarea>
        <div v-if="showHtmlEditor && emailContents" class="mt-2 pa-3" style="border:1px solid rgba(128,128,128,0.3);border-radius:4px;" v-html="emailContents"></div>
        <div v-if="availableTokens" class="pt-2 pb-0 mb-0 mt-4">
          <v-select outlined dense @change="copyToken" :label="$t('message.select_token_copy')"
            :items="availableTokens">
          </v-select>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn :loading="processingTemplate" :disabled="processingTemplate" outlined v-allowed="'create_waiver'"
          v-if="emailTemplateId == 'new' && emailTemplate.name" color="primary" small elevation="0"
          @click="creatEmailTemplate()">{{ $t('message.create') }}</v-btn>
        <v-btn :loading="processingTemplate" :disabled="processingTemplate" outlined v-allowed="'create_waiver'" small
          elevation="0" v-else-if="emailTemplate._id" color="primary" @click="updateEmailTemplate()">{{
            $t('message.update')
          }}</v-btn>
        <v-btn small elevation="0" class="ml-2" @click="goBack()">{{ $t('message.back') }}</v-btn>

        <v-btn small elevation="0" color="error" @click="archiveEmailTemplateDialog = true">{{ $t('message.archive')
          }}</v-btn>
      </v-card-actions>
    </div>
    <v-dialog v-model="archiveEmailTemplateDialog" max-width="90%">
      <v-card class="pa-2">
        <v-card-text>{{ $t('message.delete_item_confirm') }}</v-card-text>
        <v-card-actions>
          <v-btn color="error" elevation="0" @click.stop="archiveEmailTemplate()">{{ $t('message.archive') }}</v-btn>
          <v-btn color="secondary" elevation="0" @click.stop="archiveEmailTemplateDialog = false">{{ $t('message.close')
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api2 from "@/services/Api2";
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      emailTemplateId: this.$route.params.emailTemplateId,
      emailTemplate: null,
      loading: true,
      availableTemplates: [],
      selectedTemplate: null,
      archiveEmailTemplateDialog: null,
      emailContents: null,
      showHtmlEditor: false,
      editorToolbar: this.getEditorToolbar(),
      availableTokens: null,
      processingTemplate: false,
      automatedDistribution: null
    };
  },
  components: {
    VueEditor,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.availableTokens = this.getAvailabeEmailTokens();
      if (this.emailTemplateId == "new") {
        this.emailTemplate = {
          active: true,
          name: null,
          contents: "",
          managedAcademy: this.$store.state.managedAcademy,
        };
        this.loading = false;
      } else {
        this.getEmailTemplate();
      }
    },
    copyToken(val) {
      this.copyToClipboard(val);
    },
    getEmailTemplate() {
      Api2()
        .get(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/email/templates/" +
          this.emailTemplateId
        )
        .then((response) => {
          if (response) {
            this.emailTemplate = response.data.template;
            this.emailContents = this.emailTemplate.contents;
            const looksLikeHtml = this.emailContents && (
              this.emailContents.includes('<!DOCTYPE') ||
              this.emailContents.includes('<html') ||
              this.emailContents.includes('<body')
            );
            this.showHtmlEditor = this.emailTemplate.isHtml || looksLikeHtml || false;
            this.loading = false;
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          this.loading = false;
        });
    },
    async creatEmailTemplate() {
      if (!this.emailTemplate.name) {
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        return;
      }
      this.processingTemplate = true;
      this.emailTemplate.contents = this.emailContents || "";
      this.emailTemplate.isHtml = this.showHtmlEditor;

      const regexp = /data:image\/([a-zA-Z]*);base64,([^"]*)/g;
      let totalImages = 0;
      const groups = this.findMatches(this.emailTemplate.contents, regexp);
      const replacements = [];

      if (groups.length >= 1) {
        let increaseBy = Math.round((100 - this.processingImagesProgress) / (totalImages + 1));
        this.processingImages = true;
        for (const group of groups) {
          try {
            const formData = new FormData();
            const d = new Date();
            const millis = d.getTime();

            const blob = this.blobFromBase64(group);
            formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.jpg');
            const res = await Api2()
              .post("content/image/admin", formData);
            const data = res.data;
            if (data) {
              replacements.push(data.location);
              this.processingImagesProgress += increaseBy;
            }
          } catch (err) {
            console.log(err);
            this.processingImages = true;
            this.showAlert("error", "Error processing images");
            return;
          }
        }
        this.processingImagesProgress = 100;
        this.emailTemplate.contents = this.replaceMatches(this.emailTemplate.contents, regexp, replacements);
      }
      this.postNewEmailTemplate();
    },
    postNewEmailTemplate() {
      Api2()
        .post(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/email/templates",
          this.emailTemplate
        )
        .then((response) => {
          if (response) {
            this.emailTemplateId = response.data.template._id;
            this.showAlert("success", this.$t("message.success"));
            this.processingTemplate = false;
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          this.processingTemplate = false;
        });
    },
    async updateEmailTemplate() {
      this.processingTemplate = true;
      this.emailTemplate.contents = this.emailContents || "";
      this.emailTemplate.isHtml = this.showHtmlEditor;

      const regexp = /data:image\/([a-zA-Z]*);base64,([^"]*)/g;
      let totalImages = 0;

      const groups = this.findMatches(this.emailTemplate.contents, regexp);
      const replacements = [];

      if (groups.length >= 1) {
        let increaseBy = Math.round((100 - this.processingImagesProgress) / (totalImages + 1));
        this.processingImages = true;
        for (const group of groups) {
          try {
            const formData = new FormData();
            const d = new Date();
            const millis = d.getTime();

            const blob = this.blobFromBase64(group);
            formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.jpg');
            const res = await Api2()
              .post("content/image/admin", formData);
            const data = res.data;
            if (data) {
              replacements.push(data.location);
              this.processingImagesProgress += increaseBy;
            }
          } catch (err) {
            console.log(err);
            this.processingImages = true;
            this.showAlert("error", "Error processing images");
            return;
          }
        }
        this.processingImagesProgress = 100;
        this.emailTemplate.contents = this.replaceMatches(this.emailTemplate.contents, regexp, replacements);
      }
      this.patchEmailTemplate();
    },
    patchEmailTemplate() {
      Api2()
        .patch(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/email/templates/" +
          this.emailTemplateId,
          this.emailTemplate
        )
        .then((response) => {
          if (response) {
            this.showAlert("success", this.$t("message.success"));
            this.processingTemplate = false;
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          this.processingTemplate = false;
        });
    },
    archiveEmailTemplate() {
      Api2()
        .delete(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/email/templates/" +
          this.emailTemplateId
        )
        .then((response) => {
          if (response) {
            this.showAlert("success", this.$t("message.success"));
            this.goBack();
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
  },
};
</script>

<style scoped></style>